'use strict';

var cov_1o3d96ftzw = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createProposalModal/createProposalModal.js',
        hash = '39592a212a7911a4b2122bdbe1416d59b8b2042f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createProposalModal/createProposalModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 65
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 53
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 54
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 15
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 51
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewProposalModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateProposalModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 98
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 29
                    },
                    end: {
                        line: 25,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 32
                    },
                    end: {
                        line: 29,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 44
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 45
                    },
                    end: {
                        line: 30,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 65
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1o3d96ftzw.s[0]++;
(function () {
    'use strict';

    cov_1o3d96ftzw.f[0]++;
    cov_1o3d96ftzw.s[1]++;
    angular.module('app').service('NewProposalModalService', NewProposalModalService);

    /* @ngInject */
    function NewProposalModalService($mdDialog) {
        cov_1o3d96ftzw.f[1]++;
        cov_1o3d96ftzw.s[2]++;

        this.display = function () {
            cov_1o3d96ftzw.f[2]++;
            cov_1o3d96ftzw.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createProposalModal/createProposalModal.html',
                controller: CreateProposalModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateProposalModalController($scope, $mdDialog, ProposalsTable, OrganizationsTable) {
        cov_1o3d96ftzw.f[3]++;
        cov_1o3d96ftzw.s[4]++;

        $scope.newProposal = ProposalsTable.$build();
        cov_1o3d96ftzw.s[5]++;
        $scope.clients = OrganizationsTable.$search();

        cov_1o3d96ftzw.s[6]++;
        $scope.closeDialog = function () {
            cov_1o3d96ftzw.f[4]++;
            cov_1o3d96ftzw.s[7]++;

            $mdDialog.cancel();
        };

        cov_1o3d96ftzw.s[8]++;
        $scope.createProposal = function () {
            cov_1o3d96ftzw.f[5]++;
            cov_1o3d96ftzw.s[9]++;

            $scope.newProposal.$save().$then(function (proposal) {
                cov_1o3d96ftzw.f[6]++;
                cov_1o3d96ftzw.s[10]++;

                $scope.newProposal.$load('client');
                cov_1o3d96ftzw.s[11]++;
                $mdDialog.hide(proposal);
            });
        };
    }
})(angular);